// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"815":"f8a277ee","983":"569ea14b"}[chunkId] + ".chunk.css";
};